import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"
import type {
  TicketReplySubmitData,
  TicketSubmitData,
} from "@/types/ticketTypes"

export function useReplyToTicketMutation(ticketId: number) {
  return useGenereicMutation<TicketReplySubmitData>({
    method: HTTP_METHODS.POST,
    createEndpoint: () => ENDPOINTS.tickets.replies(ticketId),
    invalidationKeys: [QUERY_KEYS.tickets.show(ticketId)],
  })
}

export function useAddTicketMutation() {
  return useGenereicMutation<TicketSubmitData>({
    method: HTTP_METHODS.POST,
    createEndpoint: () => ENDPOINTS.tickets.add(),
    invalidationKeys: [QUERY_KEYS.tickets.index()],
  })
}
